import 'intersection-observer';
import React, { useEffect, useState, useReducer, createContext, useCallback } from 'react';
import axios from 'axios';
import * as s from '../ts/store';
import * as c from '../ts/const';
import Header from './containers/header';
//import SaleList from './containers/sale-list'
import Copyright from './containers/copyright';
import Column from './containers/column';
import LatestInfo from './containers/latest-info';
import SalePeriod from './containers/sale-period';
import Banner from './containers/banner';
import ASale from './components/a-sale';
import ImgPictures from './components/img-pictures';
import ImgPicture from './components/img-picture';
import { sendGtag } from '../ts/modules/sendgtag';
/**
 * セールオーダーを元にセールリストを生成する
 */
const createSaleListElements = (saleOrder) => {
    return saleOrder.map((saleProp, index) => {
        return (React.createElement(ASale, { saleProp: saleProp, key: `asale-${index}` }));
    });
};
/**
 * コンテキスト
 */
export const SaleItemsContext = createContext([]);
/**
 * 外部データの取得
 * @param fileName
 * @returns
 */
function readData(fileName) {
    return new Promise((resolve, reject) => {
        axios.get(fileName)
            .then(res => resolve(res.data));
    });
}
const Index = () => {
    const [saleItemsState, saleItemsDispatcher] = useReducer(s.saleItemsReducer, s.initialState);
    const [appRootClassName, setAppRootClassName] = useState('');
    // 商品一覧データの取得
    useEffect(() => {
        const curerntTime = (new Date()).getTime();
        // 商品一覧データのセット
        readData(`${_SALE_ITEM_LIST_PATH}?${curerntTime}`)
            .then(res => saleItemsDispatcher({ type: 'setSaleItems', value: res }));
        // セール並び順データのセット
        readData(`${_SALE_ORDER_PATH}?${curerntTime}`)
            .then(res => {
            saleItemsDispatcher({ type: 'setSaleOrder', value: res });
        });
        // ヘッダ用データのセット
        readData(`${_HEADER_PROPS_PATH}?${curerntTime}`)
            .then(res => {
            saleItemsDispatcher({ type: 'setHeaderProps', value: res });
            // ヘッダの情報が読み終わったのでページをアクティブにする
            setAppRootClassName(`active sale-period-${res.period}`);
        });
        // コラム用のデータセット
        readData(`${_COLUMN_ITEM_LIST_PATH}?${curerntTime}`)
            .then(res => saleItemsDispatcher({ type: 'setColumnItems', value: res }));
        // 最新情報用のデータセット
        readData(`${_LATEST_ITEM_LIST_PATH}?${curerntTime}`)
            .then(res => saleItemsDispatcher({ type: 'setLatestItems', value: res }));
    }, []);
    /**
     * スタオ6購入ボタンのクリック
     */
    const handleSO6OrderClick = useCallback((label) => {
        const eventPramas = {
            event_action: 'SO6',
            event_label: label,
            event_category: c.EVENT_CATEGORY
        };
        sendGtag(eventPramas, c.IS_DEV);
    }, []);
    return (React.createElement("div", { className: `app-root ${appRootClassName}` },
        React.createElement(SaleItemsContext.Provider, { value: [saleItemsState, saleItemsDispatcher] },
            React.createElement("div", { className: 'bg-grad-1 relative z-50 bg-grad-anime' },
                React.createElement("div", { className: "bg-kira" },
                    React.createElement("div", { className: "bg-moya" })),
                React.createElement("div", { className: 'bg-header-deco' }),
                React.createElement("div", { className: 'relative' },
                    React.createElement(Header, null),
                    React.createElement(SalePeriod, null))),
            React.createElement("div", { className: 'fancy-head fancy-head-1' },
                React.createElement(ImgPictures, { fileNameLarge: './assets/img/head/so6-titles-md', fileNameSmall: './assets/img/head/so6-titles-sm', ext: 'png', mediaQueryLarge: c.MEDIA_QUERY_LARGE, mediaQuerySmall: c.MEDIA_QUERY_SMALL })),
            React.createElement("div", { className: 'relative' },
                React.createElement("div", { className: 'bg-sale-1' },
                    React.createElement("div", { className: "bg-moya bg-moya-so" },
                        React.createElement("div", { className: "bg-kira bg-kira-so" }))),
                React.createElement("div", { className: 'bg-tama' }),
                React.createElement("div", { className: 'bg-so6' }),
                React.createElement("div", { className: 'relative' },
                    React.createElement("div", { className: 'base-width' },
                        React.createElement("div", { className: 'so6-sale' },
                            React.createElement(ImgPictures, { fileNameLarge: './assets/img/so6/so6-logo', fileNameSmall: './assets/img/so6/so6-image-sm', ext: 'png', mediaQueryLarge: c.MEDIA_QUERY_LARGE, mediaQuerySmall: c.MEDIA_QUERY_SMALL }),
                            React.createElement("div", { className: 'so6-sale-nav' },
                                React.createElement("div", { className: 'so6-sale-nav-item' },
                                    React.createElement("a", { onClick: () => handleSO6OrderClick('[PS5]スターオーシャン 6 THE DIVINE FORCE　PS4 ＆ PS5'), target: '_blank', href: 'https://store.playstation.com/ja-jp/product/JP0082-PPSA05924_00-STAROCEAN6PS5000/' },
                                        React.createElement(ImgPicture, { fileName: './assets/img/so6/so6-ps5', ext: 'png' }))),
                                React.createElement("div", { className: 'so6-sale-nav-item' },
                                    React.createElement("a", { onClick: () => handleSO6OrderClick('[PS5]スターオーシャン 6 THE DIVINE FORCE　PS4 ＆ PS5'), target: '_blank', href: 'https://store.playstation.com/ja-jp/product/JP0082-PPSA05924_00-STAROCEAN6PS5000/' },
                                        React.createElement(ImgPicture, { fileName: './assets/img/so6/so6-ps4', ext: 'png' }))),
                                React.createElement("div", { className: 'so6-sale-nav-item' },
                                    React.createElement("a", { onClick: () => handleSO6OrderClick('[XBOX]スターオーシャン 6 THE DIVINE FORCE'), target: '_blank', href: 'https://www.xbox.com/ja-jp/games/store/star-ocean-6/9p3twtkqrlk0' },
                                        React.createElement(ImgPicture, { fileName: './assets/img/so6/so6-xbox', ext: 'png' }))),
                                React.createElement("div", { className: 'so6-sale-nav-item' },
                                    React.createElement("a", { onClick: () => handleSO6OrderClick('[Steam]スターオーシャン 6 THE DIVINE FORCE'), target: '_blank', href: 'https://store.steampowered.com/app/1776380' },
                                        React.createElement(ImgPicture, { fileName: './assets/img/so6/so6-steam', ext: 'png' })))),
                            React.createElement("div", { className: 'so6-sale-label' },
                                React.createElement(ImgPicture, { fileName: './assets/img/so6/so6-trial-label', ext: 'png' })),
                            React.createElement("div", { className: 'so6-sale-text' },
                                "\u203B\u300E\u30B9\u30BF\u30FC\u30AA\u30FC\u30B7\u30E3\u30F3 6 THE DIVINE FORCE\u300F\u306F",
                                React.createElement("br", null),
                                "\u30BB\u30FC\u30EB\u5BFE\u8C61\u306B\u306F\u542B\u307E\u308C\u307E\u305B\u3093\u3002"))),
                    saleItemsState.saleOrder[0] && (React.createElement(ASale, { saleProp: saleItemsState.saleOrder[0] })))),
            React.createElement("div", { className: 'fancy-head fancy-head-2' },
                React.createElement(ImgPictures, { fileNameLarge: './assets/img/head/other-titles-md', fileNameSmall: './assets/img/head/other-ttiles-sm', ext: 'png', mediaQueryLarge: c.MEDIA_QUERY_LARGE, mediaQuerySmall: c.MEDIA_QUERY_SMALL })),
            React.createElement("div", { className: 'bg-sale-2 relative' },
                React.createElement("div", { className: "bg-kira" },
                    React.createElement("div", { className: "bg-moya" })),
                React.createElement("div", { className: 'bg-sale-2-deco' }),
                React.createElement("div", { className: 'relative' }, saleItemsState.saleOrder[1] && (React.createElement(ASale, { saleProp: saleItemsState.saleOrder[1] })))),
            React.createElement("div", { className: 'bg-grad-1 relative' },
                React.createElement("div", { className: "bg-kira" },
                    React.createElement("div", { className: "bg-moya" })),
                React.createElement("div", { className: 'relative bg-column-deco' },
                    React.createElement(Banner, null),
                    React.createElement(Column, null))),
            React.createElement("div", { className: 'bg-grad-2 relative' },
                React.createElement("div", { className: "bg-kira" },
                    React.createElement("div", { className: "bg-moya" })),
                React.createElement("div", { className: 'relative bg-latest-items-deco' },
                    React.createElement(LatestInfo, null))),
            React.createElement("div", { className: 'bg-grad-3 relative' },
                React.createElement("div", { className: "bg-kira" },
                    React.createElement("div", { className: "bg-moya" })),
                React.createElement("div", { className: 'relative bg-copyright' },
                    React.createElement(Copyright, null))))));
};
export default Index;
